// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting__header[data-v-0f75e0f0],.setting__item[data-v-0f75e0f0]{position:absolute;width:160px;height:54px;text-align:center;font:normal normal 700 24px/32px Segoe UI!important;letter-spacing:0;opacity:1}", ""]);
// Exports
module.exports = exports;
